<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Cooling Load VS Outdoor Temperature
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <vue-plotly v-if="data1" disable-responsive :data="data1" :layout="layout1" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 md6>
                        <vue-plotly v-if="data2" disable-responsive :data="data2" :layout="layout2" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment'
    import {getCOP} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";
    export default {
        name: 'HKLEnergy',
        components: {VuePlotly,DateRangeSelector},
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(31, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(1, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                data1:null,
                data2:null,
                layout1:{
                    title:"Cooling Load VS Outdoor Temperature : Day Mode",
                    yaxis: {
                        title: 'Cooling Load (kW)'
                    },
                    xaxis: {
                        title: 'Outdoor Temperature (°C)'
                    }
                },
                layout2:{
                    title:"Cooling Load VS Outdoor Temperature : Night Mode",
                    yaxis: {
                        title: 'Cooling Load (kW)'
                    },
                    xaxis: {
                        title: 'Outdoor Temperature (°C)'
                    }
                },
            }
        },

        methods:{
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                getCOP({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    from_date: currentRange[0],
                    to_date: currentRange[1],
                    extra_vars: [{
                        'equipment_name': 'Weather',
                        'sensor_names': ['Outdoor_Temperature']
                    }]
                }).then(function(result){
                    let splitData={
                       day:{
                           weekday:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           },
                           weekend:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           }
                       },
                       night:{
                           weekday:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           },
                           weekend:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           }
                       }
                    }
                    for (let index in result.timestamp){
                        let theTime = moment(result.timestamp[index])
                        let firstIndex= theTime.hour()<5 ? "night" : "day"
                        let secondIndex= theTime.day()<6 ? "weekday" : "weekend"
                        splitData[firstIndex][secondIndex].timestamp.push(result.timestamp[index])
                        splitData[firstIndex][secondIndex].Cooling_Load.push(result.Cooling_Load[index])
                        splitData[firstIndex][secondIndex].Outdoor_Temperature.push(result.Outdoor_Temperature[index])
                    }
                    me.data1=[
                        {
                            x:splitData.day.weekday.Outdoor_Temperature,
                            y:splitData.day.weekday.Cooling_Load,
                            hovertext:splitData.day.weekday.timestamp,
                            mode:"markers",
                            name:"Weekday"
                        },
                        {
                            x:splitData.day.weekend.Outdoor_Temperature,
                            y:splitData.day.weekend.Cooling_Load,
                            hovertext:splitData.day.weekend.timestamp,
                            mode:"markers",
                            name:"Weekend"
                        }
                    ]
                    me.data2=[
                        {
                            x:splitData.night.weekday.Outdoor_Temperature,
                            y:splitData.night.weekday.Cooling_Load,
                            hovertext:splitData.night.weekday.timestamp,
                            mode:"markers",
                            name:"Weekday"
                        },
                        {
                            x:splitData.night.weekend.Outdoor_Temperature,
                            y:splitData.night.weekend.Cooling_Load,
                            hovertext:splitData.night.weekend.timestamp,
                            mode:"markers",
                            name:"Weekend"
                        }
                    ]
                    me.loading=false
                })


            }

        },
        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.baseDate=moment(preconf.rangeStart)
                this.endDate=moment(preconf.rangeEnd)
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
            } else if(maxDate){
                this.baseDate=moment(maxDate).subtract(31, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
